import { useState, useEffect } from 'react';
import api from '../api';

/**
 * Custom hook to fetch Groudon rarity information from the backend
 * Used to determine whether to display regular Groudon or Diamond Groudon
 * @returns {Object} { loading, error, showDiamond, groudonCount, diamondGroudonCount }
 */
const useGroudonRarity = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rarityData, setRarityData] = useState({
    showDiamond: false,
    groudonCount: 0,
    diamondGroudonCount: 0
  });

  useEffect(() => {
    const fetchGroudonRarity = async () => {
      try {
        setLoading(true);
        const response = await api.get('/v1/battle-tower/check-groudon-rarity');
        setRarityData({
          showDiamond: response.data.show_diamond,
          groudonCount: response.data.groudon_count,
          diamondGroudonCount: response.data.diamond_groudon_count
        });
        setError(null);
      } catch (err) {
        console.error('Error fetching Groudon rarity:', err);
        setError(err.message || 'Failed to fetch Groudon rarity');
      } finally {
        setLoading(false);
      }
    };

    fetchGroudonRarity();
  }, []);

  return {
    loading,
    error,
    showDiamond: rarityData.showDiamond,
    groudonCount: rarityData.groudonCount,
    diamondGroudonCount: rarityData.diamondGroudonCount
  };
};

export default useGroudonRarity;